import {
	ACCOUNT_LINK_SET_STEP,
	ACCOUNT_LINK_STORE_DATA,
	ACCOUNT_LINK_GET_MANAGER_BY_CPF_STARTED,
	ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED,
	ACCOUNT_LINK_GET_RELATIONSHIP_STARTED,
	ACCOUNT_LINK_GET_RELATIONSHIP_FINISHED,
	ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_STARTED,
	ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_FINISHED,
	ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_STARTED,
	ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_FINISHED,
	ACCOUNT_LINK_SEARCH_MANAGER_BY_CPF_CLEAN,
	ACCOUNT_LINK_IF_RENDER_MODAL_INVALID_CPF,
	ACCOUNT_LINK_PARTICIPANT_SENDING_FILE
} from "../shared/constants";

const INITIAL_STATE = {
	dataRelationshipParticipant: [],
	dataApproveInvite: undefined,
	dataCurrentStepParticipant: 0,
	dataToSendParticipant: {
		cpf: undefined,
		scannedStatement: undefined
	},
	sendingFile: 0,
	hasManager: false,
	isInvalidCPF: false,
	isBlockedPer24h: false,
	isFailureLimitReached: false,
	renderModalInvalidCPF: false,
	isOneLessAttempt: false,
	isLoading: {
		onSearchByCPFParticipant: false,
		getRelationshipsParticipant: false,
		onApproveInvite: false,
		onCancelRelationshipParticipant: false
	}
};

const AccountLinkReducer = (state = INITIAL_STATE, { type, payload } = action) => {
	switch (type) {
		case ACCOUNT_LINK_GET_RELATIONSHIP_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					getRelationshipsParticipant: true
				}
			};
		case ACCOUNT_LINK_GET_RELATIONSHIP_FINISHED:
			return {
				...state,
				...payload,
				isLoading: {
					...state.isLoading,
					getRelationshipsParticipant: false
				},
				dataApproveInvite: undefined
			};
		case ACCOUNT_LINK_GET_MANAGER_BY_CPF_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onSearchByCPFParticipant: true
				}
			};
		case ACCOUNT_LINK_GET_MANAGER_BY_CPF_FINISHED:
			return {
				...state,
				...payload,
				isLoading: {
					...state.isLoading,
					onSearchByCPFParticipant: false
				}
			};
		case ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onApproveInvite: true
				}
			};
		case ACCOUNT_LINK_PARTICIPANT_APPROVE_INVITE_FINISHED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onApproveInvite: false
				},
				...payload
			};

		case ACCOUNT_LINK_PARTICIPANT_SENDING_FILE:
			return {
				...state,
				sendingFile: state.sendingFile + payload.sendingFile
			};

		case ACCOUNT_LINK_SEARCH_MANAGER_BY_CPF_CLEAN:
			return {
				...state,
				dataToSendParticipant: {
					cpf: undefined,
					scannedStatement: undefined
				},
				dataApproveInvite: undefined
			};
		case ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_STARTED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onCancelRelationshipParticipant: payload
				}
			};
		case ACCOUNT_LINK_PARTICIPANT_CANCEL_RELATIONSHIP_FINISHED:
			return {
				...state,
				isLoading: {
					...state.isLoading,
					onCancelRelationshipParticipant: false
				}
			};

		case ACCOUNT_LINK_SET_STEP:
			return {
				...state,
				dataCurrentStepParticipant: payload
			};

		case ACCOUNT_LINK_IF_RENDER_MODAL_INVALID_CPF:
			return {
				...state,
				renderModalInvalidCPF: false
			};
		case ACCOUNT_LINK_STORE_DATA:
			return {
				...state,
				dataToSendParticipant: {
					...state.dataToSendParticipant,
					...payload
				},
				isInvalidCPF: false,
				hasManager: false
			};
		default:
			return state;
	}
};

export default AccountLinkReducer;
